import { Box, BoxProps, ColorOptions, Loader, LoaderNew, ModBox, Text, useWindowDimensions } from '@jfs/ui-new'
import { useFocusEffect, useNavigation } from '@react-navigation/native'
import React, { useEffect, useState } from 'react'
import ActionsMenu from '../../../../components/ActionMenu/ActionsMenu'
import { Filters } from '../../../../components/FiltersWeb'
import { filterTypes } from '../../../../components/FiltersWeb/types'
import { NewTable } from '../../../../components/NewTable'
import { useLazyApiData, useStores } from '../../../../data/store'
import { filtersData } from '../../../../utils'
import { aadharCheckerHeaderTitles, getCustomColumnWidth } from '../../../../utils/constants'

const Header = ({ fetchDataOnChange, filterVisible, setFilterVisible, filterApplied, exportFile }: any) => {
  return (
    <Box {...styles.header}>
      <ModBox w={'100%'}>
        <Text title={'My Queue (Checker)'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
        <ActionsMenu
          fetchDataOnChange={fetchDataOnChange}
          filterVisible={filterVisible}
          setFilterVisible={setFilterVisible}
          showSearch={true}
          enableFilter
          showCalendar
          defaultPage={1}
          type="aadharRedactionChecker"
          filterApplied={filterApplied}
          showExport={true}
          handleExport={exportFile}
        />
      </ModBox>
    </Box>
  )
}
const AadharCheckerQueue = () => {
  const {
    fetchAadharRedactionListChecker,
    getAadharRedactionGlobalList,
    aadharRedactionCheckerListLength,
    checkSelected,
    selectedFilteredData,
    updateFilters,
    setSideMenuRefresh,
    saveState,
    resetState,
    restoreFiltersToDefaults,
    setSearchFilterBy,
    resetFeePkgId,
    resetCheckerApplicationStatus,
    clearAadharRedactionsEditedNonEditedDocs,
    applicationRetry,
    exportRecords,
  } = useStores((store) => ({
    fetchAadharRedactionListChecker: store.getAadharRedactionGlobalCheckerList,
    getAadharRedactionGlobalList: store.getAadharRedactionCheckerList,
    aadharRedactionCheckerListLength: store.aadharRedactionCheckerList.length,
    checkSelected: store.filter.checkSelected,
    selectedFilteredData: store.filter.getFilterData,
    updateFilters: store.filter.updateFilters,
    setSideMenuRefresh: store.setSideMenuRefresh,
    saveState: store.filter.saveState,
    resetState: store.filter.resetState,
    restoreFiltersToDefaults: store.filter.restoreFiltersToDefaults,
    applicationStatusLength: store.filter.applicationStatus.length,
    getSelectedGlobalListLength: store.getAadharRedactionGlobalListLength(),
    setSearchFilterBy: store.onboarding.setSearchFilterBy,
    resetFeePkgId: store.onboarding.resetFeePkgId,
    resetCheckerApplicationStatus: store.resetCheckerApplicationStatus,
    clearAadharRedactionsEditedNonEditedDocs: store.clearAadharRedactionsEditedNonEditedDocs,
    applicationRetry: store.applicationRetry,
    exportRecords: store.exportFiuRecords,
  }))
  const { width } = useWindowDimensions()
  const navigation = useNavigation()

  const [listData, setListData] = useState<any>([])
  const [isLoading, setLoading] = useState(false)
  const [filterVisible, setFilterVisible] = useState(false)
  const [lazyExportFile, exportFiuFileHandler] = useLazyApiData(exportRecords)

  const exportFile = (fileType: any) => lazyExportFile('AADHAR_REDACTION', fileType)

  const [lazyGetGlobalCheckerList, globalCheckerListHandler] = useLazyApiData(fetchAadharRedactionListChecker)
  const [retryApi, applicationRetryHandler] = useLazyApiData(applicationRetry)

  useEffect(() => {
    if (applicationRetryHandler?.state === 'fulfilled' || applicationRetryHandler?.state === 'rejected') {
      if (
        applicationRetryHandler?.state === 'fulfilled' &&
        applicationRetryHandler?.data?.status?.toLowerCase() === 'success'
      ) {
        lazyGetGlobalCheckerList('', '')
      }
    }
  }, [applicationRetryHandler?.data?.status, applicationRetryHandler?.state, lazyGetGlobalCheckerList])
  useEffect(() => {
    if (globalCheckerListHandler.state === 'fulfilled' || globalCheckerListHandler.state === 'rejected') {
      const list = getAadharRedactionGlobalList()
      setListData(list)
      setLoading(false)
      clearAadharRedactionsEditedNonEditedDocs()
    }
  }, [
    getAadharRedactionGlobalList,
    globalCheckerListHandler.state,
    aadharRedactionCheckerListLength,
    clearAadharRedactionsEditedNonEditedDocs,
  ])

  useFocusEffect(
    React.useCallback(() => {
      setLoading(true)
      lazyGetGlobalCheckerList('', '')
      setSideMenuRefresh(true)
      setSearchFilterBy('Entity ID')
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []),
  )

  const fetchDataOnChange = () => {
    console.count('===> fetchDataOnChange')
    setLoading(true)
    lazyGetGlobalCheckerList('', '')
  }

  const onPress = (item: any) => {
    console.log('onpress aadhar checker: ', JSON.parse(JSON.stringify(item)))
    if (item?.applicationStatus === 'Error') {
      navigation.reset({
        index: 0,
        routes: [
          {
            name: 'aadharRedactionDetails',
            params: { itemData: item, from: 'AD_CHECKER', isApprovedByChecker: true, type: 'AD_CHECKER' },
          },
        ],
      })
    } else if (item?.applicationStatus === 'Rejected') {
      navigation.reset({
        index: 0,
        routes: [
          {
            name: 'aadharRedactionDetails',
            params: {
              itemData: item,
              from: 'AD_CHECKER',
              isApprovedByChecker: false,
              showApproveReject: false,
              type: 'AD_CHECKER',
            },
          },
        ],
      })
    } else if (item?.applicationStatus === 'Completed') {
      navigation.reset({
        index: 0,
        routes: [
          {
            name: 'aadharRedactionDetails',
            params: {
              itemData: item,
              from: 'AD_CHECKER',
              isApprovedByChecker: false,
              showApproveReject: false,
              type: 'AD_CHECKER',
            },
          },
        ],
      })
    } else {
      navigation.reset({
        index: 0,
        routes: [
          {
            name: 'aadharRedactionDetails',
            params: {
              itemData: item,
              from: 'AD_CHECKER',
              isApprovedByChecker: false,
              showApproveReject: true,
              type: 'AD_CHECKER',
            },
          },
        ],
      })
    }
  }

  const onRetry = (item: any) => {
    console.log('Item: ', JSON.parse(JSON.stringify(item)))
    retryApi(item?.applicationId, true, 'AADHAR_REDACTION')
  }
  const handleFilterVisibility = (visible: boolean) => {
    setFilterVisible(visible)
    if (visible) {
      saveState()
    }
  }

  const onFilterPress = () => {
    setFilterVisible(false)
    resetState()
  }

  const applyFilter = () => {
    fetchDataOnChange()
    setFilterVisible(false)
  }

  const restoreFilterDefaults = () => {
    restoreFiltersToDefaults()
  }

  if (isLoading) {
    return <Loader />
  }

  return (
    <ModBox {...styles.container} show={!isLoading}>
      <Header
        fetchDataOnChange={fetchDataOnChange}
        filterVisible={filterVisible}
        setFilterVisible={handleFilterVisibility}
        filterApplied={
          selectedFilteredData?.applicationStatus?.length > 0 &&
          !selectedFilteredData?.applicationStatus?.includes('ALL')
        }
        exportFile={exportFile}
      />
      <ModBox padding={16} show={!filterVisible}>
        <NewTable
          data={listData}
          rowHeight={48}
          headerHeight={64}
          height={544}
          customWidthFunc={getCustomColumnWidth}
          tableWidth={width > 1200 ? width - 290 : width}
          headerRowKeys={aadharCheckerHeaderTitles}
          onRowClick={onPress}
          onRetry={onRetry}
        />
      </ModBox>
      <ModBox show={filterVisible}>
        <Filters
          onPress={onFilterPress}
          selectedFilteredData={selectedFilteredData}
          updateFilters={updateFilters}
          filterData={[filtersData]}
          checkSelected={checkSelected}
          apply={applyFilter}
          selectedValue={selectedFilteredData?.applicationStatus}
          mode={filterTypes?.applicationStatus}
          restoreDefaults={restoreFilterDefaults}
        />
      </ModBox>
      <ModBox
        position={'absolute'}
        top={0}
        left={0}
        right={0}
        bottom={0}
        backgroundColor={'TRANSPARENT'}
        show={exportFiuFileHandler.state === 'pending'}
        justifyContent={'center'}>
        <LoaderNew color={'PRIMARY'} type={'large'} />
      </ModBox>
    </ModBox>
  )
}

export default AadharCheckerQueue

export const styles = {
  container: {
    h: '100%',
    bg: 'WHITE',
    shadowRadius: 8,
    shadowColor: '#0000001F' as ColorOptions,
    borderRadius: 8,
    minHeight: 720,
    overflow: 'auto',
  } as BoxProps,
  header: {
    flexDirection: 'row',
    p: 16,
    h: 100,
    w: '100%',
    marginBottom: 16,
  } as BoxProps,
  footer: {
    p: 12,
    direction: 'row',
    justify: 'flex-end',
    alignItems: 'center',
    borderTopWidth: 1,
    borderTopColor: '#0000001F' as ColorOptions,
  } as BoxProps,
  tabbarView: {
    alignSelf: 'center',
  } as BoxProps,
}
